<template>
  <div class="date-selection-row" :class="customClass">
    <div class="btn-date-today-wrap">
      <button
        type="button"
        class="btn-date-today"
        :class="{
          'is-current': selectedDate === currentDate,
          'is-past-shows': pastShowsActive,
        }"
        @click="goToToday"
      >
        Today
      </button>
      <ul v-if="isPastShowsMenuOpen" class="past-shows-menu">
        <li
          class="past-shows-menu-item"
          :class="{ active: pastShowsActive }"
          @click="onSelectPastShows(true)"
        >
          Show Past Shows
        </li>
        <li
          class="past-shows-menu-item"
          :class="{ active: !pastShowsActive }"
          @click="onSelectPastShows(false)"
        >
          Show Current Shows
        </li>
      </ul>
    </div>
    <!-- Prev Button -->
    <button
      type="button"
      class="btn-date-arrow"
      @click.stop="prevSlide"
      :title="$t('previous') || 'Previous'"
    >
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="15 18 9 12 15 6"></polyline>
      </svg>
    </button>

    <div class="date-selection-container" v-if="dates && dates.length > 0">
      <slick ref="slick1" :options="mergedSliderOptions">
        <div v-for="(dateLoop, loop) in dates" :key="loop">
          <div
            v-on:click="onChangeTab(dateLoop)"
            :class="[
              'date-slider-box',
              selectedDate == dateLoop
                ? 'active cursor-pointer'
                : allowPastBooking == 'Y'
                ? 'cursor-pointer'
                : new Date(currentDate) > new Date(dateLoop)
                ? 'cursor-pointer'
                : 'cursor-pointer',
              selectedDate == dateLoop && selectedDate != currentDate
                ? 'date-not-today-blink'
                : '',
            ]"
          >
            <div class="text-center">
              <span>{{ dateLoop }}</span>
              <div class="lh-1" style="font-size:80%">
                {{ dateLoop | dayparse }}
              </div>
            </div>
          </div>
        </div>
      </slick>
    </div>

    <!-- Next Button -->
    <button
      type="button"
      class="btn-date-arrow"
      @click.stop="nextSlide"
      :title="$t('next') || 'Next'"
    >
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="9 18 15 12 9 6"></polyline>
      </svg>
    </button>
  </div>
</template>

<script>
  import Slick from "vue-slick";
  import moment from "moment";
  import { EventBus } from "@/main";

  export default {
    props: {
      childComponents: {
        type: Object,
      },
      customClass: {
        type: String,
        default: "",
      },
      dateSelectionSlider: {
        type: Object,
        default: {
          infinite: false,
          dots: false,
          arrows: true,
          slidesToShow: 1,
        },
      },
      onChangeTab: {
        type: Function,
      },

      selectedTabIndex: {
        type: Number,
        default: 0,
      },
      // when true, clicking "Today" while today is already selected opens the
      // past shows option instead of doing nothing
      enablePastShows: {
        type: Boolean,
        default: false,
      },
      pastShowsActive: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      Slick,
    },
    data() {
      return {
        currentDate: "",
        cinema_id: "",
        isPastShowsMenuOpen: false,
      };
    },
    beforeMount() {},
    mounted() {
      this.currentDate = moment().format("DD-MM-YYYY");
      document.addEventListener("click", this.onDocumentClick);
      this.$nextTick(() => {
        this.scrollToCurrentDate();
      });
    },
    beforeDestroy() {
      document.removeEventListener("click", this.onDocumentClick);
    },
    watch: {
      dates: {
        handler(newDates) {
          if (newDates && newDates.length) {
            this.$nextTick(() => {
              this.scrollToCurrentDate();
            });
          }
        },
      },
      'childComponents.isSlideSlick'(val) {
        if (val) {
          this.$nextTick(() => {
            this.scrollToCurrentDate();
            if (this.childComponents) {
              this.childComponents.isSlideSlick = false;
            }
          });
        }
      },
    },
    computed: {
      mergedSliderOptions() {
        return {
          infinite: false,
          dots: false,
          slidesToShow: 5,
          slidesToScroll: 2,
          ...this.dateSelectionSlider,
          arrows: false,
        };
      },
      dates() {
        return (this.childComponents && this.childComponents.getDatesArray) || [];
      },
      allowPastBooking() {
        return "N";
      },
      selectedDate() {
        return (
          (this.childComponents && this.childComponents.SELECTED_DATE) ||
          this.currentDate
        );
      },
    },
    methods: {
      // The slider is inside v-if="dates.length", so the ref can be missing or not yet
      // initialised; every call goes through here and is a no-op until it exists.
      callSlider(method, ...args) {
        const slider = this.$refs && this.$refs.slick1;
        if (!slider || typeof slider[method] !== "function") return;
        try {
          slider[method](...args);
        } catch (err) {
          console.warn("posDateSlider: slick." + method + " failed", err);
        }
      },
      scrollToCurrentDate() {
        if (!this.dates || !this.dates.length) return;
        const target = this.selectedDate || this.currentDate;
        const idx = this.dates.findIndex((d) => d === target);
        if (idx >= 0) {
          this.callSlider("goTo", idx, true);
        }
      },
      prevSlide() {
        this.callSlider("prev");
      },
      nextSlide() {
        this.callSlider("next");
      },
      goToToday() {
        if (!this.currentDate) {
          this.currentDate = moment().format("DD-MM-YYYY");
        }
        if (this.selectedDate === this.currentDate) {
          if (this.enablePastShows) {
            this.isPastShowsMenuOpen = !this.isPastShowsMenuOpen;
          }
          return;
        }
        this.isPastShowsMenuOpen = false;
        if (this.childComponents) {
          this.childComponents.isSlideSlick = true;
        }
        if (typeof this.onChangeTab === "function") {
          this.onChangeTab(this.currentDate);
        }
      },
      onSelectPastShows(status) {
        this.isPastShowsMenuOpen = false;
        if (status === this.pastShowsActive) {
          return;
        }
        this.$emit("toggle-past-shows", status);
      },
      onDocumentClick(event) {
        if (!this.isPastShowsMenuOpen) {
          return;
        }
        if (this.$el && !this.$el.contains(event.target)) {
          this.isPastShowsMenuOpen = false;
        }
      },
    },
  };
</script>

<style>
  .pointer-none {
    cursor: no-drop;
    pointer-events: none;
  }

  .width97 {
    width: 95% !important;
  }

  .date-selection-row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 15px;
  }

  .date-selection-row .date-selection-container {
    flex: 1;
    min-width: 0;
    margin-bottom: 0;
    width: auto;
  }

  .btn-date-today-wrap {
    position: relative;
    flex-shrink: 0;
  }

  .past-shows-menu {
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    z-index: 1050;
    min-width: 165px;
    margin: 0;
    padding: 4px 0;
    list-style: none;
    background: #fff;
    border: 1px solid #e0e0e0;
    border-radius: var(--posGlobalRadius);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  .past-shows-menu-item {
    padding: 8px 14px;
    font-size: 13px;
    white-space: nowrap;
    cursor: pointer;
  }

  .past-shows-menu-item:hover {
    background: #f2f6ff;
  }

  .past-shows-menu-item.active {
    color: var(--blue);
    font-weight: 600;
  }

  .btn-date-today {
    flex-shrink: 0;
    height: 40px;
    padding: 0 14px;
    border: 1px solid var(--blue);
    background: #fff;
    color: var(--blue);
    border-radius: var(--posGlobalRadius);
    font-weight: 600;
    font-size: 13px;
    line-height: 1;
    cursor: pointer;
    white-space: nowrap;
    transition: background-color 0.2s, color 0.2s;
  }

  .btn-date-today:hover {
    background: var(--blue);
    color: #fff;
  }

  .btn-date-today.is-current {
    background: var(--blue);
    color: #fff;
  }

  .btn-date-today.is-past-shows {
    background: #ff9800;
    border-color: #ff9800;
    color: #fff;
  }

  .date-slider-box.date-not-today-blink {
    animation: date-not-today-blink 1s ease-in-out infinite;
    background-color: rgba(255, 152, 0, 0.18);
    border-bottom-color: #ff9800;
    color: #e65100;
  }

  @keyframes date-not-today-blink {
    0%,
    100% {
      opacity: 1;
      background-color: rgba(255, 152, 0, 0.28);
      box-shadow: inset 0 0 0 1px rgba(255, 152, 0, 0.45);
    }
    50% {
      opacity: 0.55;
      background-color: rgba(255, 152, 0, 0.08);
      box-shadow: inset 0 0 0 1px transparent;
    }
  }

  /* Date slider arrow buttons */
  .btn-date-arrow {
    flex-shrink: 0;
    width: 32px;
    height: 40px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 1px solid var(--blue, #8d6fbf);
    border-radius: var(--posGlobalRadius, 8px);
    background: #ffffff;
    color: var(--blue, #8d6fbf);
    cursor: pointer;
    transition: all 0.15s ease;
    padding: 0;
  }

  .btn-date-arrow:hover {
    background: var(--blue, #8d6fbf);
    color: #ffffff;
    box-shadow: 0 2px 8px rgba(141, 111, 191, 0.25);
  }

  .btn-date-arrow:active {
    transform: scale(0.93);
  }

  /* Hide default floating slick arrows to prevent clipping and overlap */
  .date-selection-container .slick-prev,
  .date-selection-container .slick-next {
    display: none !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Partials/posDateSlider.vue